import React from 'react';
import { useGroupsReset } from '../../hooks/useGroupsReset';
import { usePersonManagementReset, useSearchListsReset } from '../../hooks/usePersonManagementReset';
import { PageFactory } from '../../../../global/components/page-factory';

export function GroupsLanding() {
    usePersonManagementReset();
    useGroupsReset();
	useSearchListsReset();

	return (
		<>
			<PageFactory />
		</>
	);
}